import React from "react";

const ModalMenuPrimary = (props) => {
  return (
    <nav className="menu-primary">
      <ul className="nav">
        <li className="nav-item">
          <a
            title="Services"
            href={process.env.PUBLIC_URL + "/#services"}
            onClick={props.close}
          >
            Services
          </a>
        </li>

        <li className="nav-item">
          <a
            title="About Us"
            href={process.env.PUBLIC_URL + "/#about-me"}
            onClick={props.close}
          >
            About Me
          </a>
        </li>

        <li className="nav-item">
          <a
            title="Teams"
            href={process.env.PUBLIC_URL + "/#projects"}
            onClick={props.close}
          >
            Projects
          </a>
        </li>

        <li className="nav-item">
          <a
            title="Contact"
            href={process.env.PUBLIC_URL + "/#contact"}
            onClick={props.close}
          >
            Contact
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default ModalMenuPrimary;
